/** Extract invite code from pasted link or raw code string. */

export function parseInviteCodeInput(input: string): string | null {
  const trimmed = input.trim();
  if (!trimmed) return null;

  try {
    if (trimmed.includes('://') || trimmed.startsWith('/')) {
      const base =
        typeof window !== 'undefined' && window.location?.origin
          ? window.location.origin
          : 'https://scoutlytics.gg';
      const url = new URL(trimmed, base);
      const queryCode = url.searchParams.get('code');
      if (queryCode) return queryCode.trim() || null;
      const match = url.pathname.match(/\/join\/([^/]+)\/?$/);
      if (match?.[1]) return decodeURIComponent(match[1]);
    }
  } catch {
    // fall through to raw code
  }

  if (trimmed.includes('/join/')) {
    const parts = trimmed.split('/join/');
    const tail = parts[parts.length - 1]?.split(/[?#]/)[0];
    if (tail) return decodeURIComponent(tail.trim());
  }

  return trimmed;
}
